import Dexie from 'dexie';

const DB_NAME = 'GazaPharmacyDB_v12';

const db = new Dexie(DB_NAME);

db.version(1001).stores({
  medicines: '++id, name, generic_name, category_id, supplier_id, barcode, sku',
  categories: '++id, name, description',
  batches: '++id, medicine_id, batch_number, quantity, cost_price, selling_price, mf_date, expiry_date, [medicine_id+batch_number]',
  customers: '++id, name, phone, email, address, credit_limit, balance, notes',
  suppliers: '++id, name, phone, email, address, balance, credit_balance, notes',
  sales: '++id, invoice_number, customer_id, user_id, subtotal, discount, tax, total, payment_method, payment_status, paid_amount, checkout_paid_amount, notes, [payment_status+created_at]',
  sale_items: '++id, sale_id, medicine_id, batch_id, quantity, unit_price, discount, total',
  purchases: '++id, reference_number, supplier_id, user_id, purchase_date, payment_method, subtotal, discount, tax, total, payment_status, paid_amount, checkout_paid_amount, balance_due, notes, [payment_status+created_at]',
  purchase_items: '++id, purchase_id, medicine_id, batch_number, mf_date, expiry_date, quantity, buy_price, sell_price, discount, total',
  customer_payments: '++id, customer_id, payment_date, payment_method, amount, sale_id, client_request_id, notes, user_id, created_at, [customer_id+payment_date]',
  supplier_payments: '++id, supplier_id, payment_date, payment_method, amount, notes, user_id, created_at, [supplier_id+payment_date]',
  supplier_refunds: '++id, supplier_id, purchase_id, refund_date, refund_type, refund_amount, medicine_id, return_quantity, user_id, created_at',
  expenses: '++id, expense_type_id, category, description, amount, payment_method, date, user_id, [category+date], [expense_type_id+date]',
  users: '++id, username, full_name, email, role, password_hash, is_active',
  staff: '++id, name, phone, address, age, salary_amount, advanced_payment, notes',
  expense_types: '++id, name, color, is_active, sort_order',
  damages: '++id, medicine_id, batch_id, damage_date, quantity, reason, notes, user_id, created_at, [medicine_id+damage_date]',
  syncQueue: '++id, table_name, record_id, operation, endpoint, method, synced, created_at, [synced+created_at]',
  customer_refunds: '++id, customer_id, sale_id, refund_date, refund_type, refund_amount, medicine_id, return_quantity, user_id, created_at',
  customer_refund_items: '++id, customer_refund_id, medicine_id, return_quantity, unit_price, refund_amount, created_at',
  supplier_refund_items: '++id, supplier_refund_id, medicine_id, return_quantity, unit_price, refund_amount, created_at',
  formulations: '++id, name',
});

db.version(1002).stores({
  daily_closings: '++id, business_date, staff_id, staff_name, role, invoice_count, total_sales, cash_sales, card_sales, online_sales, credit_sales, closed_by, closed_at, status, notes, [business_date+staff_id]',
});

db.version(1003).stores({
  cash_transactions: '++id, type, amount, account_name, category, reason, reference, notes, transaction_date, user_id, created_at, [type+transaction_date]',
});

db.version(1004).stores({
  staff_transactions: '++id, staff_id, type, amount, deduction_amount, net_paid, payment_method, expense_id, user_id, transaction_date, notes, created_at, [staff_id+type]',
});

// Upgrade the existing offline database in place. Do not change DB_NAME: doing
// so would abandon queued receipts while a device is offline.
db.version(1005).stores({
  sales: '++id, invoice_number, customer_id, user_id, subtotal, discount, tax, total, payment_method, payment_status, paid_amount, checkout_paid_amount, notes, [payment_status+created_at]',
  customer_payments: '++id, customer_id, payment_date, payment_method, amount, sale_id, client_request_id, notes, user_id, created_at, [customer_id+payment_date]',
});

db.version(1006).stores({
  purchases: '++id, reference_number, supplier_id, user_id, purchase_date, payment_method, subtotal, discount, tax, total, payment_status, paid_amount, checkout_paid_amount, balance_due, notes, [payment_status+created_at]',
});

db.on('versionchange', () => {
  window.location.reload();
});

async function initDB() {
  try {
    await db.open();
    console.log('Dexie DB opened:', DB_NAME);
  } catch (error) {
    console.warn('DB open failed, clearing and retrying...', error.message);
    await new Promise((resolve) => {
      const req = indexedDB.deleteDatabase(DB_NAME);
      req.onsuccess = () => resolve();
      req.onerror = () => resolve();
      req.onblocked = () => resolve();
    });
    window.location.reload();
  }
}

initDB();

export default db;
